import { useTranslation } from "react-i18next";
import { useStore } from "../../../helpers";
import { useRequestTypeMutation } from "./useAddServiceRequestType";
import { useParams } from "react-router-dom";
import { useLocalStorage } from "react-use";
import { useQueryClient } from "@tanstack/react-query";

export const useAddServiceRequestSubject = () => {
    const rootStore = useStore();
    const {
        serviceRequestsStore: { setSubjectId },
    } = rootStore;
    const { projectid } = useParams();
    const [value, setValue] = useLocalStorage("sr-subject", "{}");
    const { t } = useTranslation("service_request_components");

    const addSerivceRequest = async (payload: any) => {
        const { profile, additional, voter_presence, ...others } = payload;
        const finalPayload = {
            projectid: parseInt(projectid),
            voter_attached: false,
            voter_presence: voter_presence,
            subject: {
                profile,
                ...others,
            },
            additional,
            more: {},
        };
        const response = await rootStore.apiRequestHandler(
            "unified_service_request/sr-subjects-add",
            finalPayload,
            t("couldnot_createsr")
        );
        // if (response.ok) {
        //   setValue(JSON.parse(JSON.stringify(response?.data)));
        // }
        // if (response.ok) {
        //     setValue(JSON.parse(JSON.stringify(response?.data)));
        //     rootStore.serviceRequestsStore.setActiveServiceRequest(
        //         JSON.parse(JSON.stringify(response.data))
        //     );
        //     setSubjectId(response?.data?.["id"]);
        // }
        if (response.ok) {
            // Store only subject ID – not full object
            setValue(JSON.stringify({ id: response?.data?.["id"] }));

            rootStore.serviceRequestsStore.setActiveServiceRequest(
                JSON.parse(JSON.stringify(response.data))
            );

            setSubjectId(response?.data?.["id"]);
        }

        console.log(response, "response here looking for SUb ID");
        return response;
    };

    return useRequestTypeMutation(
        addSerivceRequest,
        t("sr_added_successfully")
    );
};

export const useUpdateServiceRequestSubject = () => {
    const rootStore = useStore();
    const [value, setValue] = useLocalStorage("sr-subject", "{}");
    const { t } = useTranslation("service_request_components");

    const updateServiceRequest = async (payload: any) => {
        const { subject, ...rest } = payload;
        const { voter_presence, ...subjectRest } = subject;

        const finalPayload = {
            ...rest,
            voter_presence: voter_presence,
            subject: {
                ...subjectRest,
            },
        };

        const response = await rootStore.apiRequestHandler(
            "unified_service_request/sr-subjects-update",
            finalPayload,
            t("couldnot_updatesr")
        );
        if (response.ok) {
            setValue(JSON.parse(JSON.stringify(response?.data)));
        }
        return response;
    };

    return useRequestTypeMutation(
        updateServiceRequest,
        t("sr_update_successfully")
    );
};

export const useDeleteServiceRequestSubject = () => {
    const rootStore = useStore();
    const queryClient = useQueryClient();
    const { t } = useTranslation("service_request_components");

    const deleteServiceRequest = async (payload: any) => {
        return rootStore.apiRequestHandler(
            "unified_service_request/service-requests-delete",
            payload,
            t("couldnot_deletesr")
        );
    };
    const mutation = useRequestTypeMutation(
        deleteServiceRequest,
        t("sr_deleted_successfully")
    );

    const wrappedMutate = (payload: any) => {
        mutation.mutate(payload, {
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: ["service-requests"],
                });

                queryClient.invalidateQueries(["sr-list"]);
                queryClient.invalidateQueries(["my-sr-list"]);

                rootStore.serviceRequestsStore.setshowServiceRequest(false);
                rootStore.serviceRequestsStore.setActiveServiceRequest(null);
            },
        });
    };

    return {
        ...mutation,
        mutate: wrappedMutate,
    };
};

export const useAddServiceRequest = () => {
    const rootStore = useStore();
    const { t } = useTranslation("service_request_components");

    const addSerivceRequest = async (payload: any) => {
        return rootStore.apiRequestHandler(
            "unified_service_request/service-requests-add",
            payload,
            t("couldnot_createsr")
        );
    };

    return useRequestTypeMutation(
        addSerivceRequest,
        t("sr_added_successfully")
    );
};

export const useUpdateServiceRequest = () => {
    const rootStore = useStore();
    const { t } = useTranslation("service_request_components");

    const addSerivceRequest = async (payload: any) => {
        return rootStore.apiRequestHandler(
            "unified_service_request/service-requests-update",
            payload,
            t("couldnot_updatesr")
        );
    };

    return useRequestTypeMutation(
        addSerivceRequest,
        t("sr_update_successfully")
    );
};
